import { errorHandlerActionTypes } from '@/components/errorHandler/Constants';

import type {
	ClearErrorAction,
	CustomNotification,
	ErrorType,
	HandleErrorAction,
} from '@/components/errorHandler/types';

export function handleError(
	error: unknown,
	typeError: ErrorType = 'page-blocking',
	customNotification: CustomNotification | null = null,
): HandleErrorAction {
	return {
		type: errorHandlerActionTypes.HANDLE_ERROR,
		payload: {
			error,
			typeError,
			customNotification,
		},
	};
}

export function clearError(): ClearErrorAction {
	return {
		type: errorHandlerActionTypes.CLEAR_ERROR,
	};
}
